export enum CommissionPaymentStatusType {
  Created = "Created",
  Processing = "Processing",
  Success = "Success",
  Error = "Error"
}
